import { render, staticRenderFns } from "./crudManage.vue?vue&type=template&id=61c3a06c&scoped=true"
import script from "./crudManage.vue?vue&type=script&lang=ts"
export * from "./crudManage.vue?vue&type=script&lang=ts"
import style0 from "./crudManage.vue?vue&type=style&index=0&id=61c3a06c&prod&lang=scss&scoped=true"
import style1 from "./crudManage.vue?vue&type=style&index=1&id=61c3a06c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c3a06c",
  null
  
)

export default component.exports